export default __webpack_public_path__ + "static/media/Kartofel.d93df1a8.png";